module.exports = __webpack_public_path__ + "abb4ffd1e847bc37b98929aaba1cbad6.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/jg-logomark.svg
// module id = 906
// module chunks = 0